import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'smTruncate' })
export class SmTruncatePipe implements PipeTransform {
    transform(value: string, limit: number): string {
        if (value && value.length > limit) {
            return value.substr(0, limit) + '...';
        }
        else {
            return value;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/pipes/sm-truncate.pipe.ts